/* eslint-disable sonarjs/cognitive-complexity */
/* eslint-disable security/detect-object-injection */
import { Injectable, inject } from '@angular/core';
import { Observable, from, of } from 'rxjs';
import { finalize, first, map, switchMap, tap } from 'rxjs/operators';
import { NavigationService } from '../api-generated/api/api';
import NavService from '../services/nav.service';
import ContractService from '../services/contract.service';
import LoadingService from '../services/loading.service';
import { AuthService } from '@bbj/components';
import LocalTaskService from '@services/local-task.service';

@Injectable()
export default class LoginUserResolve {
  private contractService = inject(ContractService);
  private loadingService = inject(LoadingService);
  private authService = inject(AuthService);
  private navService = inject(NavService);
  private navigationService = inject(NavigationService);
  localTaskService = inject(LocalTaskService);

  loginAttempts = 0;

  resolve(): Observable<void> {
    this.loadingService.start();
    return from(this.authService.login()).pipe(
      tap(()=>this.localTaskService.fetchData()),
      switchMap((userId) => {
        if (!userId) {
          return of();
        }
        return this.navigationService.getAllMenus('portal');
      }),
      map((root) => {
        const loginUser = root.user;
        if (!loginUser) {
          return;
        }
        const permission = this.authService.getPermission();
        this.navService.setUserItem(loginUser.givenName, loginUser.surname, loginUser.id, loginUser.mail, loginUser.companyName, permission);
        this.navService.iuser = root.user;
        this.navService.setBroughData(root.boroughNavigation);
        this.navService.setGlobalData(root.globalNavigation);
        this.navService.setDataSubject(root.combinedBoroughs);
        if (root.globalNavigation.length) {
          this.navService.setSelectedId(
            root.globalNavigation[0].globalModule.Guid,
          );
        } else if (root.boroughNavigation.length) {
          this.navService.setSelectedId(
            root.boroughNavigation[0].boroughItem.Guid,
          );

          this.contractService.setSelected(
            root.boroughNavigation[0].projects[0],
          );
        }
        return;
      }),
      first(),
      finalize(() => this.loadingService.stop()),
    );
  }
}
